import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface AccordionProps {
  question: string;
  answer: string;
}
export function Accordion({
  question,
  answer
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-2 border-charcoal bg-white rounded-sm mb-4 overflow-hidden" data-id="element-129">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex justify-between items-center p-5 text-left bg-white hover:bg-cement transition-colors" aria-expanded={isOpen} data-id="element-130">
        <span className="font-heading font-bold text-xl text-charcoal pr-4" data-id="element-131">
          {question}
        </span>
        <ChevronDown className={`h-6 w-6 text-amber-dark flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} strokeWidth={3} data-id="element-132" />
      </button>

      <div className={`grid transition-all duration-300 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-133">
        <div className="overflow-hidden" data-id="element-134">
          <div className="p-5 pt-0 text-lg text-charcoal font-body border-t-2 border-cement" data-id="element-135">
            {answer}
          </div>
        </div>
      </div>
    </div>;
}